import { Provider } from "react-redux";
import { store } from "./redux/store";
import Router from "./router/Router";
import { ToastContainer } from "react-toastify";
import FontUploader from "./helpers/FontUploader";
import "typeface-roboto";

//css
import "react-toastify/dist/ReactToastify.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {
  const queryClient = new QueryClient();
  var css =
    " margin:3px; color:black; font-size:20px; text-shadow: 3px 3px 3px 10px  rgba(21, 3, 255, 1);  ";
  FontUploader();
  console.log("%c 法蒂赫 $)", css);

  return (
    <Provider store={store}>
      <ToastContainer style={{ fontSize: "13px" }} />
      <QueryClientProvider client={queryClient}>
        <Router />
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
